export const BASE_ACTIONS = {
  SWITCH_ACCOUNT: 'Switch account',
  PROFILE: 'Profile and API tokens',
  LOG_OUT: 'Log out',
};

export const ADMIN_CURATOR_ACTIONS = {
  ADMIN_PANEL: 'Go to the admin panel',
  ...BASE_ACTIONS,
};
